import { motion } from "framer-motion";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { money } from "@/lib/api";

export const ProductCard = ({ product }) => {
  const { add } = useCart();

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
  };

  const handleAdd = () => {
    if (!add(product)) {
      toast.error("Max 5 pairs per order. Your 999 Rs deal is ready in the bag!");
      return;
    }
    toast.success(`${product.name} added to bag`);
  };

  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`product-card-${product.id}`}
      className="group"
    >
      <div onMouseMove={onMove} className="relative aspect-[4/5] overflow-hidden rounded-[28px] bg-plum">
        <img src={product.image} alt={`${product.name} printed socks by Insane Circle`} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-110" />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
        <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
          style={{ background: "radial-gradient(260px circle at var(--x) var(--y), rgba(204,255,0,0.28), transparent 60%)" }} />
        {product.badge && (
          <span className="absolute left-4 top-4 rounded-full bg-pink px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-wider">{product.badge}</span>
        )}
        <motion.button whileHover={{ scale: 1.1, rotate: 90 }} whileTap={{ scale: 0.85 }} onClick={handleAdd}
          data-testid={`add-to-cart-${product.id}`} aria-label={`Add ${product.name} to cart`}
          className="absolute bottom-4 right-4 flex h-12 w-12 items-center justify-center rounded-full bg-lime text-ink shadow-[0_0_30px_rgba(204,255,0,0.5)]">
          <Plus className="h-6 w-6" strokeWidth={3} />
        </motion.button>
      </div>
      <div className="mt-4 flex items-baseline justify-between gap-3 px-1">
        <h3 className="font-display text-lg font-bold uppercase leading-tight sm:text-xl">{product.name}</h3>
        <span data-testid={`product-price-${product.id}`} className="font-mono text-base font-bold text-lime">{money(product.price)}</span>
      </div>
    </motion.article>
  );
};
